export default __webpack_public_path__ + "static/media/OSMOS_CENERE_C2_GRIP_120X120_07.da80773b.jpg";